import React from 'react'
import { Trans } from '@lingui/macro'

export type PasswordRequirement = {
  id: string
  renderLabel: () => any
  checkFulfilled: (password: string) => boolean
}

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: 'min_length',
    renderLabel: () => <Trans>Aspoň 12 znakov</Trans>,
    checkFulfilled: pass => pass?.trim()?.length >= 12,
  },
  {
    id: 'number',
    renderLabel: () => <Trans>Aspoň 1 číslo</Trans>,
    checkFulfilled: pass => /\d/.test(pass),
  },
  {
    id: 'lowercase',
    renderLabel: () => <Trans>Aspoň 1 malé písmeno</Trans>,
    checkFulfilled: pass => /[a-z]/.test(pass),
  },
  {
    id: 'uppercase',
    renderLabel: () => <Trans>Aspoň 1 veľké písmeno</Trans>,
    checkFulfilled: pass => /[A-Z]/.test(pass),
  },
  {
    id: 'special_char',
    renderLabel: () => <Trans>Aspoň 1 špeciálny znak</Trans>,
    checkFulfilled: pass => /[^A-Za-z0-9]/.test(pass),
  },
]

/**
 * Vrátí ID všech splněných pravidel
 */
export const getValidRequirementIds = (password: string): PasswordRequirement[] => {
  let validRequirements: PasswordRequirement[] = []

  if (password) {
    validRequirements = PASSWORD_REQUIREMENTS.filter(r => r.checkFulfilled(password))
  }

  return validRequirements
}

/**
 * Vrátí true, pokud heslo splňuje všechna pravidla
 */
export const isPasswordStrong = (password: string): boolean => {
  return getValidRequirementIds(password).length === PASSWORD_REQUIREMENTS.length
}

/**
 * Vrátí seznam ID pravidel, která nejsou splněná
 */
export const getInvalidPasswordRequirements = (password: string): PasswordRequirement[] => {
  const validRequirements = getValidRequirementIds(password).map(r => r.id)
  return PASSWORD_REQUIREMENTS.filter(r => !validRequirements.includes(r.id))
}
